import React from 'react';
import { Translator } from 'ggApp/modules/translator';

export default function PriceSuffix({ selectedRentalPlan }) {
    return (
        <Translator
            tk="PRODUCT_CARD_PRICE_SUFFIX_MODIFIED"
            withValues={{ duration: selectedRentalPlan && selectedRentalPlan.minimumMonths }}
        />
    );
}
